import { CampaignFrontendAsset } from "./CampaignFrontendAsset";
export const isDisplayActionCampaignFrontendAsset = (asset) => {
    return asset.type === "DISPLAY_ACTION";
};
export class DisplayActionCampaignFrontendAsset extends CampaignFrontendAsset {
    constructor(parameters) {
        super({
            type: "DISPLAY_ACTION",
            step: parameters.step,
            trigger: parameters.trigger,
            component: parameters.component,
            isLegacyCampaign: parameters.isLegacyCampaign,
            campaignVersion: parameters.campaignVersion,
        });
        this.action = parameters.action;
    }
    getActionId() {
        return this.action.action_id;
    }
    getAssetHandle() {
        return this.getActionId();
    }
    getPreview() {
        const inputEventName = this.getInputEventName();
        const journeyName = this.getJourneyName();
        if (!inputEventName || !journeyName) {
            return null;
        }
        return {
            campaignId: this.getCampaignId(),
            campaignVersion: this.getCampaignVersion(),
            zoneName: inputEventName,
            journeyName,
        };
    }
}
